import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SubmitStatus = "idle" | "loading" | "success" | "error";

interface SupportTicketState {
  submitStatus: SubmitStatus;
  ticketId: string | null;
  errorMessage: string | null;
}

const initialState: SupportTicketState = {
  submitStatus: "idle",
  ticketId: null,
  errorMessage: null,
};

const supportTicketSlice = createSlice({
  name: "supportTicket",
  initialState,
  reducers: {
    setSubmitLoading: (state) => {
      state.submitStatus = "loading";
      state.ticketId = null;
      state.errorMessage = null;
    },
    setSubmitSuccess: (state, action: PayloadAction<string>) => {
      state.submitStatus = "success";
      state.ticketId = action.payload;
      state.errorMessage = null;
    },
    setSubmitError: (state, action: PayloadAction<string>) => {
      state.submitStatus = "error";
      state.errorMessage = action.payload;
    },
    resetSubmitState: (state) => {
      state.submitStatus = "idle";
      state.ticketId = null;
      state.errorMessage = null;
    },
  },
});

export const {
  setSubmitLoading,
  setSubmitSuccess,
  setSubmitError,
  resetSubmitState,
} = supportTicketSlice.actions;

export default supportTicketSlice.reducer;
